import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './UserWidget.module.css';
import { Card, Col, Row } from 'react-bootstrap';
import { Pencil } from 'react-bootstrap-icons';
import { WidgetsContext } from '../../GlobalContex';

function getWidgetTitle(widget) {
  const appName = widget.app?.name;
  if (appName === 'instagram-feed' && widget.settings?.account) {
    return `@${widget.settings.account.username}`;
  }

  if (appName === 'youtube-feed' && widget.settings?.channel) {
    const title = widget.settings.channel.replace(/^https:\/\/www\.youtube\.com/, '');
    return title.length > 20 ? title.slice(0, 20) + '...' : title;
  }

  if (appName === 'twitter-feed' && widget.settings?.account) {
    return `@${widget.settings.account}`;
  }

  if (appName === 'twitch-feed' && widget.settings?.channel) {
    const title = widget.settings.channel.replace(/^https:\/\/www\.twitch\.tv/, '');
    return title.length > 20 ? title.slice(0, 20) + '...' : title;
  }

  if (appName === 'facebook-feed' && widget.settings?.page) {
    return widget.settings.page.name;
  }

  if (appName === 'tiktok-feed' && widget.settings?.account) {
    return widget.settings.account.username;
  }
  return '';
}

const UserWidget = props => {
  const navigate = useNavigate();
  const { setActiveWidget, dataWidgetsList, setActiveWidgetMeta } = useContext(WidgetsContext);
  const { widget } = props;

  if (!widget) return null;
  if (widget.json) return null;

  const handleClick = () => {
    const { widget } = props;
    // reset the widget layout data (until the new widget is loaded, the settings of the old widget are displayed)
    setActiveWidgetMeta({});
    setActiveWidget(widget);

    dataWidgetsList.includes(widget.app?.name)
      ? navigate(`/widgets/${widget.id}/builder`)
      : navigate(`/widgets/${widget.id}/styles`);
  };

  const title = getWidgetTitle(widget);

  return (
    <Col xs={12} className={'mb-3'}>
      <Card
        className={`item-list ${styles.project} ${props.active && 'item-list-active'}`}
        onClick={handleClick}
      >
        <Card.Body>
          <Row className={'align-items-center g-3'}>
            <Col>
              <Card.Subtitle className="m-0">{props.widget.title}</Card.Subtitle>
              {title && <Card.Title className="m-0 mt-2">{title}</Card.Title>}
            </Col>
            <Col xs={'auto'}>
              <Pencil size={24} />
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Col>
  );
};

export default UserWidget;
